import React from "react";
import { useStore } from "react-redux";
import { BERATER_KENNZEICHEN } from "../../utils/enums/BERATER_KENNZEICHEN";
import { formatCurrency } from "../../utils/functions";

export const EdelmetallSumme = (props) => {
  const {
    emProvZusKz,
    beraterFeld,
  } = props || {};
  const { configStorage, basketStorage } = useStore().getState();

  const direktbestellung = basketStorage.doShip !== "no";
  const warenkorb = basketStorage.orderDataForOrder ? basketStorage.orderDataForOrder.edelmetallWarenkorb || {} : {};
  const selectedFiliale = basketStorage.selectedFiliale;
  const beraterkennzeichen = configStorage.getBeraterKennzeichen();

  // display positive values
  let gebuehren = Number(warenkorb.gebuehren);
  let versandkosten = Math.abs(Number(warenkorb.versandkosten));

  //  Für jeden Artikel fallen spezifische Gebühren an.
  let gesamtProvision = basketStorage.getEnthalteneProvision().getPrice();
  let hasProvisionZusatz = (emProvZusKz === "J") && (beraterFeld === "J");

  return (
    <div className="row justify-content-end">
      <div className="col-12 col-md-10 col-lg-8 float-end table-scroll">
        <table className="table table-bordered table-responsive-xs fs-5 text-end">
          <tbody>
            <tr>
              <th className="active">Produktpreis netto:</th>
              <td className="text-end">
                {formatCurrency(warenkorb.netto)}
              </td>
            </tr>
            {beraterkennzeichen !== BERATER_KENNZEICHEN.KEIN_BERATERKENNZEICHEN && beraterFeld === "J"
              ? (
                <tr>
                  <th className="active">davon Provisionen{hasProvisionZusatz?'**:':':'}</th>
                  <td className="text-end">
                    {formatCurrency(gesamtProvision)}
                  </td>
                </tr>
              )
              : null
            }
            <tr>
              <th className="active">Versandkosten:</th>
              <td className="text-end">
                {formatCurrency(versandkosten)}
              </td>
            </tr>
            <tr>
              <th className="active">Konditions&shy;änderungen/Gebühren:</th>
              <td className="text-end">
                {formatCurrency(gebuehren)}
              </td>
            </tr>
            <tr>
              <th className="active">MwSt.*:</th>
              <td className="text-end">
                {formatCurrency(warenkorb.steuer)}
              </td>
            </tr>
            <tr className="fw-bold">
              <th className="active">
                Endsumme:
              </th>
              <td className="text-end">
                {formatCurrency(warenkorb.summe)}
              </td>
            </tr>
            {!direktbestellung && selectedFiliale !== null && !configStorage.isAnkaufShop()
              ? (
                <tr>
                  <th className="active">Filiale</th>
                  <td>
                    {selectedFiliale.name}
                  </td>
                </tr>
              )
              : null
            }
          </tbody>
        </table>
        <p className="text-end fs-6">
          * inkl. MwSt. auf Konditionsänderungen/Gebühren und Direktversandkosten von MwSt.-pflichtigen Produkten
        </p>
        {hasProvisionZusatz
          ? <p className="text-end fs-6">
            ** Darüber hinaus kann das Institut in Abhängigkeit von der Vertriebsleistung eine weitergehende
            Vergütung von 0,5 % auf steuerfreie Edelmetallumsätze erhalten.
          </p>
          : null
        }
      </div>
    </div>
  );
};
